/* eslint-disable jsx-a11y/alt-text */
import { FunctionComponent } from 'react';
import Modal from '../../Utility/Modal/Modal';
import Button from '../../Input/Button/Button';

import styles from './ViewPDFModal.module.scss';

type ViewPDFModalProps = {
  pdfPath: string;
  isVisible: boolean;
  onDisagree: () => void;
};

type FC = FunctionComponent<ViewPDFModalProps>;

const ViewPDFModal: FC = (props: ViewPDFModalProps) => {
  const { pdfPath, isVisible, onDisagree } = props;
  return (
    <Modal isVisible={isVisible} enableBgClick onBgClick={() => onDisagree()}>
      <div className={[styles.container].join(' ')}>
        <iframe src={`${pdfPath}#toolbar=0`} style={{ width: '90vw', height: '90vh', border: 'none' }}></iframe>
        <div className={styles.crossContainer}>
          <Button
            id='create-report-dialog-close"'
            color="secondary"
            label=""
            iconLocation="center"
            icon="cross"
            iconSize="md"
            iconWidth="17px"
            background="none"
            noShadow
            onClick={() => {
              onDisagree();
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
export default ViewPDFModal;
